module.exports = __webpack_public_path__ + "media/images/riders/LORIS_VERGIER-ce7c28099753128c1b2cfdb2f7a1fee0.png";